import { render } from "./mänguLõpp.vue?vue&type=template&id=604c9078&scoped=true"
import script from "./mänguLõpp.vue?vue&type=script&lang=js"
export * from "./mänguLõpp.vue?vue&type=script&lang=js"

import "./mänguLõpp.vue?vue&type=style&index=0&id=604c9078&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604c9078"]])

export default __exports__